import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

export default function OtherWagonDetails(props) {
  const { wagonTechnicalDetails, classes, expanded, handleChange } = props;
  const [wagonTechnicalDetailsState, setWagonTechnicalDetailsState] =
    React.useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (wagonTechnicalDetails !== undefined) {
      setWagonTechnicalDetailsState(wagonTechnicalDetails);
    }
  }, [wagonTechnicalDetails]);
  return (
    <div>
      {wagonTechnicalDetailsState && (
        <Accordion
          className={classes.accordion}
          expanded={expanded}
          onChange={handleChange}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography className={classes.heading}> {t('others')}</Typography>
            <Typography className={classes.secondaryHeading}>
              {t('More wagon details')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.container}>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={1}>
                  <FormLabel className={classes.formLabel}>
                    {t('Ladder')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Crash buffer')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Coating type')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('UIC Type')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Brakes blocks')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Wagon type')}
                  </FormLabel>
                </Grid>{' '}
                <Grid item xs={1}>
                  <FormLabel className={classes.formLabel}>GPS </FormLabel>
                </Grid>
                <Grid item xs={1}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.ladder !== null &&
                    wagonTechnicalDetailsState.ladder !== ''
                      ? wagonTechnicalDetailsState.ladder
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.crashBuffers !== null
                      ? wagonTechnicalDetailsState.crashBuffers === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.coatingType !== null &&
                    wagonTechnicalDetailsState.coatingType !== ''
                      ? wagonTechnicalDetailsState.coatingType
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.uicType !== null &&
                    wagonTechnicalDetailsState.uicType !== ''
                      ? wagonTechnicalDetailsState.uicType
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.brakeBlocks !== null &&
                    wagonTechnicalDetailsState.brakeBlocks !== ''
                      ? wagonTechnicalDetailsState.brakeBlocks
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.wagonType !== null &&
                    wagonTechnicalDetailsState.wagonType !== ''
                      ? wagonTechnicalDetailsState.wagonType
                      : '-'}
                  </FormLabel>
                </Grid>{' '}
                <Grid item xs={1}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.gps !== null
                      ? wagonTechnicalDetailsState.gps === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
